/**
 * Tiny LRU of "recently visited" issues, persisted to localStorage so the
 * command palette can offer them as quick links.
 */

const KEY = 'bos.recent';
const MAX = 5;

export function getRecentItems() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]');
  } catch {
    return [];
  }
}

export function pushRecentItem(item) {
  if (!item?.key) return;
  const existing = getRecentItems().filter((i) => i.key !== item.key);
  const next = [{ key: item.key, title: item.title || item.key, url: item.url || `/pm/issues/${item.key}` }, ...existing].slice(0, MAX);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // localStorage full or disabled — silent fallback
  }
}

export function clearRecentItems() {
  try { localStorage.removeItem(KEY); } catch { /* noop */ }
}
